import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
  apiKey: '0a064184fe4c72c62a6c12b2554fc432',
  plugins: [new BugsnagPluginReact()]
})

export default Bugsnag;